import { useState } from "react";
import EditRelationshipModal from "../../Components/EditRelationship/editModal";
import AddRelationshipForm from "../../Components/AddRelationshipForm";
import ConfirmInviteModal from "../../Components/ConfirmInviteModal";
import { checkUserExists } from "../../Services/auth";
import { assignLicense, getUserSubscriptionDetails } from "../../Services/subscription";


function AddRelationShipChatModal({
  title,
  onClose,
  contact,
  onAddClick,
  onAddedRelationShip,
  showEmail,
  isSurveyAdd = false,
  addRelationShipWithAvailableLicense,
  licenseDetails,
  subscriptionId,
  noErrorOnReturn,
  selectedLicence,
  skipClose = false,
}) {
  const [confirmInviteOpen, setConfirmInviteOpen] = useState(false);
  const [confirmInviteData, setConfirmInviteData] = useState(null);

  // Helper: assign selected/unassigned licenses to the partner user from relationship response
  const assignLicensesForSurvey = async (relPayload) => {
    const selectedAssignmentIds = Array.isArray(selectedLicence) && selectedLicence.length
      ? selectedLicence
      : [licenseDetails?.[0]?.assignment_id].filter(Boolean);
    if (!selectedAssignmentIds.length) return;
    // Assign each selected license to the partner user
    for (const assignmentId of selectedAssignmentIds) {
      await assignLicense({
        license_id: assignmentId,
        email: (contact?.email || relPayload?.email || relPayload?.contact?.email || "").toLowerCase(),
        first_name: contact?.first_name || relPayload?.first_name || "",
        last_name: contact?.last_name || relPayload?.last_name || "",
      }).catch(() => { });
    }
  };

  return (
    <div className="careeradvice-modal-overlay">
      <div className="careeradvice-modal">
        <div className="careeradvice-modal-header">
          <div>
            <h2 className="careeradvice-modal-title">{title || "Add Relationship"}</h2>
          </div>
          {!skipClose && (
            <div>
              <button className="careeradvice-close-button" onClick={onClose}>
                ×
              </button>
            </div>
          )}
        </div>

        <div className="manage-add-container">

          <AddRelationshipForm
            onCancel={onClose}
            onSuccess={async (res) => {
              // Consider success only when payload/data carry an id or status is explicitly success
              const tmp = res?.payload || res?.data || null;
              const relationId = tmp?._id || tmp?.relation_id;
              const isExplicitSuccess = res?.status === 'success' || Boolean(tmp);
              const isSuccess = Boolean(relationId) || isExplicitSuccess;
              if (!isSuccess) return; // keep modal open if error

              const related = tmp?.user1_to_user2 || tmp?.related_data || {};
              const contact_relational_data = {
                relationship_category: related?.relationship_category || tmp?.relationship_category || "",
                relationship_type: related?.relationship_type || tmp?.relationship_type || "",
                relationship_length: related?.relationship_length || tmp?.relationship_length || "",
                relationship_status: related?.relationship_status || tmp?.relationship_status || "",
                relationship_goals: related?.relationship_goals ?? tmp?.relationship_goals ?? null,
              };

              // If survey flow and licenses available/selected, assign them now (outside the form component)
              if (isSurveyAdd && ((licenseDetails?.length > 0 && addRelationShipWithAvailableLicense) || (Array.isArray(selectedLicence) && selectedLicence.length > 0))) {
                await assignLicensesForSurvey(tmp);
              }

              onAddedRelationShip?.({
                type: "initiateRelationship",
                text: "I need relationship advice for ",
                name: `${tmp?.first_name || ""} ${tmp?.last_name || ""}`.trim(),
                contact_relational_data,
                relation_id: relationId,
              });

              onClose?.();
            }}
            onCheckMember={({ via, email, country_code, contact }) => {
              if (via === "email") {
                return checkUserExists({ email });
              }
              return checkUserExists({ country_code, contact });
            }}
            openConfirmInvite={({ form, notifyVia, photo, onConfirm }) => {
              setConfirmInviteData({ form, notifyVia, photo, onConfirm });
              setConfirmInviteOpen(true);
            }}
            hideTitle={true}
            initialValues={contact}
            // Hide share UI and show email-only field for survey or license flows
            isSurveyAdd={isSurveyAdd || !!addRelationShipWithAvailableLicense}
            emailOnlyMode={!!addRelationShipWithAvailableLicense}
          />
          <ConfirmInviteModal
            open={confirmInviteOpen}
            onClose={() => setConfirmInviteOpen(false)}
            contactName={`${confirmInviteData?.form?.first_name || ""} ${confirmInviteData?.form?.last_name || ""}`.trim()}
            category={confirmInviteData?.form?.relationship_category}
            photo={confirmInviteData?.photo}
            emailOrPhone={
              confirmInviteData?.notifyVia === "email"
                ? confirmInviteData?.form?.email
                : `${confirmInviteData?.form?.country_code || ""} ${confirmInviteData?.form?.contact || ""}`
            }
            onConfirm={async () => {
              const fn = confirmInviteData?.onConfirm;
              setConfirmInviteOpen(false);
              await fn?.();
              // Do not close the modal here; AddRelationshipForm.onSuccess will close on success.
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default AddRelationShipChatModal;
